import apiInstance from "./axios";
import {
  tip_offers,
  tip_offer_applicants,
  tip_offer_apply,
  tip_offer_select,
  tip_offer_cancel,
} from "utils/services/api/schemas";

const tipOfferApi = {
  createOffer: async (data) => {
    const response = await apiInstance.post(tip_offers, data);
    return response;
  },

  getMyOffers: async (params) => {
    const response = await apiInstance.get(tip_offers, { params });
    return response;
  },

  getOffer: async (id) => {
    const response = await apiInstance.get(`${tip_offers}/${id}`);
    return response;
  },

  getApplicants: async (id) => {
    const response = await apiInstance.get(
      `${tip_offers}/${id}/${tip_offer_applicants}`
    );
    return response;
  },

  applyToOffer: async (id, data) => {
    const response = await apiInstance.post(
      `${tip_offers}/${id}/${tip_offer_apply}`,
      data
    );
    return response;
  },

  selectCaddy: async (id, data) => {
    const response = await apiInstance.post(
      `${tip_offers}/${id}/${tip_offer_select}`,
      data
    );
    return response;
  },

  cancelOffer: async (id) => {
    const response = await apiInstance.post(
      `${tip_offers}/${id}/${tip_offer_cancel}`
    );
    return response;
  },
};

export default tipOfferApi;
